import React from 'react'
import { createContext, useState, useMemo } from "react";
import AuthContext from "./AuthContext";
import StatusContext from "./StatusContext";
import ClientContext from "./ClientContext";
import axios from "axios"
import { commonsamples } from "../data/CommonSamples.ts"
import { commonsamples_Serbian } from "../data/CommonSamples_Serbian.ts"
import { commonsamples_Spanish } from "../data/CommonSamples_Spanish.ts"
import { commonsamples_Portuguese } from "../data/CommonSamples_Portuguese.ts"
import { commonsamples_French } from "../data/CommonSamples_French.ts"
import { commonsamples_German } from "../data/CommonSamples_German.ts"
import { config } from '../config';
import { sortChats } from './StatusContext';


const CommonTasksContext = createContext();

export default CommonTasksContext;

export const CommonTasksProvider = ((props) => {
    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);
    const [chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [confirmDelete, setConfirmDelete] = useState([])
    const [status, setStatus] = useState('');
    const [statusCustomPrompts, setCustomPromptsStatus] = useState('');
    const [showcustompromptdialog,setShowCustomPromptDialog] = useState(false)
    const [customprompt, setCustomPrompt] = useState({id: 0, default: false, name:'', prompt:''})
    const [showdeletedialog, setShowDeleteDialog] = useState(false)
    const [showsavedialog, setShowSaveDialog] = useState(false)
    const [dialogboxtext, setDialogBoxText] = useState('')
    const [addpromptmode, setAddPromptMode] = useState(false)
    const [displaycustompromptsdialog, setDisplayCustomPromptsDialog] = useState(false)
  
    const {
        currentUser,
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        temperature,
       
        mainLanguage,
        changeLanguage,
        setIsLoading,
        isLoading,
        getChats,
        setShowLoginDialog,
        handleFocus,
        setWaitOnResponse,
        getAIProvider, 
        getAIModel,
        getAIName,
       
    } = React.useContext(StatusContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);

    const [customprompts, setCustomPrompts] = useState([
        { id: 0, default: true, name: changeLanguage("common", "shortcutgrammar"), prompt: changeLanguage("common", "promptgrammar")},
        { id: 1, default: true, name: changeLanguage("common", "shortcutsummary"), prompt: changeLanguage("common", "promptsummary")},
        { id: 2, default: true, name: changeLanguage("common", "shortcutcompact"), prompt:changeLanguage("common", "promptcompact")},
        { id: 3, default: true, name: changeLanguage("common", "shortcutstory"), prompt: changeLanguage("common", "promptstory")},
        { id: 4, default: true, name: changeLanguage("common", "shortcutimprove"), prompt: changeLanguage("common", "promptimprove")},
        { id: 5, default: true, name: changeLanguage("common", "shortcutemail"), prompt: changeLanguage("common", "promptemail")},
        { id: 6, default: true, name: changeLanguage("common", "shortcutdescription"), prompt: changeLanguage("common", "promptdescription")},
        { id: 7, default: true, name: changeLanguage("common", "shortcutkeywords"), prompt: changeLanguage("common", "promptkeywords")}
    ]);

const onShowDeleteCustomPromptDialog = (prompt) => {
    setDialogBoxText(`${changeLanguage("common", "dialogdelete")} '${prompt.name}'?`)
    setShowDeleteDialog(true)
}


const getCustomPrompts = async () => {
       
    let allprompts = {
        prompts: [],
        status: 0,
    }

    let prompts = []
    let q = "/deda_ai_api/customprompts/getcustomprompts"

    try{

        const res = await axios.post(config.url.API_URL + q, {currentUser}) 

        if (res.data.length > 0)
        {
            // Row is found
            if (res.data[0].customprompts) {
              // Column has a value
              prompts = JSON.parse(res.data[0].customprompts)

             
            } else {
              // Column does not have a value
              console.log("Row is found but column does not have a value")
            
              prompts = [
                { id: 0, default: true, name: changeLanguage("common", "shortcutgrammar"), prompt: changeLanguage("common", "promptgrammar")},
                { id: 1, default: true, name: changeLanguage("common", "shortcutsummary"), prompt: changeLanguage("common", "promptsummary")},
                { id: 2, default: true, name: changeLanguage("common", "shortcutcompact"), prompt:changeLanguage("common", "promptcompact")},
                { id: 3, default: true, name: changeLanguage("common", "shortcutstory"), prompt: changeLanguage("common", "promptstory")},
                { id: 4, default: true, name: changeLanguage("common", "shortcutimprove"), prompt: changeLanguage("common", "promptimprove")},
                { id: 5, default: true, name: changeLanguage("common", "shortcutemail"), prompt: changeLanguage("common", "promptemail")},
                { id: 6, default: true, name: changeLanguage("common", "shortcutdescription"), prompt: changeLanguage("common", "promptdescription")},
                { id: 7, default: true, name: changeLanguage("common", "shortcutkeywords"), prompt: changeLanguage("common", "promptkeywords")}
            ]
                
            
            }
        } else {
            console.log("Row is not found")
          
        }
       
    } 
    catch(err)
    {
        console.log("Received error:", err)
        //setStatus(`Error: ${checkServerCode(err.code)}`)
        if (err.response && err.response.status !== 200)
        {
            allprompts.status = err.response.status
            return allprompts;
        }
    }
   
    allprompts = {prompts: prompts, status: 200}
    setCustomPrompts(prompts)
    return allprompts;
}

const fetchPrompts = async () => {

    if (checkCurrentUser() === false)
        return
    const allprompts = await getCustomPrompts();
    return allprompts
};

    const addNewPrompt = (newPrompt) => {
        setCustomPrompts((prevPrompts) => [
            ...prevPrompts,
            newPrompt
        ]);
    };
    var sortedPrompts = useMemo(() => {
        return [...customprompts].sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });
    }, [customprompts]); // No dependencies, so it will only be created once.


    const getPromptIndexByName= (prompt) => {
        for (const item of customprompts) {
            if (item.name === prompt.name)
               return item.id;
        }

        return -1;

    }
    const displaySample = (sample) => {
        console.log("displaySample:", sample)
        if (sample === "Grammar")
        {
            console.log("Grammar Sample:", commonsamples[0])
            if (mainLanguage === 'Serbian')
                displayChat(commonsamples_Serbian[0])
            else if (mainLanguage === 'Spanish')
                displayChat(commonsamples_Spanish[0])
            else if (mainLanguage === 'Portuguese')
                displayChat(commonsamples_Portuguese[0])
            else if (mainLanguage === 'French')
                displayChat(commonsamples_French[0])
            else if (mainLanguage === 'German')
                displayChat(commonsamples_German[0])
            else
                displayChat(commonsamples[0])

            setStatus(changeLanguage('status', 'exampletext19'))
        }
        if (sample === "Keywords")
        {
            console.log("Keywords Sample:", commonsamples[1])
            if (mainLanguage === 'Serbian')
                displayChat(commonsamples_Serbian[1])
            else  if (mainLanguage === 'Spanish')
                displayChat(commonsamples_Spanish[1])
            else if (mainLanguage === 'Portuguese')
                displayChat(commonsamples_Portuguese[1])
            else if (mainLanguage === 'French')
                displayChat(commonsamples_French[1])
            else if (mainLanguage === 'German')
                displayChat(commonsamples_German[1])
            else
                displayChat(commonsamples[1])
            setStatus(changeLanguage('status','exampletext19'))
        }
        if (sample === "Summary")
        {
            console.log("Summary Sample:", commonsamples[2])
            if (mainLanguage === 'Serbian')
                displayChat(commonsamples_Serbian[2])
            else  if (mainLanguage === 'Spanish')
                displayChat(commonsamples_Spanish[2])
            else if (mainLanguage === 'Portuguese')
                displayChat(commonsamples_Portuguese[2])
            else if (mainLanguage === 'French')
                displayChat(commonsamples_French[2])
            else if (mainLanguage === 'German')
                displayChat(commonsamples_German[2])
             else
                displayChat(commonsamples[2])
            setStatus(changeLanguage('status', 'exampletext19'))
        }
        if (sample === "Compact")
        {
            console.log("Compact Sample:", commonsamples[3])
            if (mainLanguage === 'Serbian')
                displayChat(commonsamples_Serbian[3])
            else if (mainLanguage === 'Spanish')
                displayChat(commonsamples_Spanish[3])
            else if (mainLanguage === 'Portuguese')
                displayChat(commonsamples_Portuguese[3])
            else if (mainLanguage === 'French')
                displayChat(commonsamples_French[3])
            else if (mainLanguage === 'German')
                displayChat(commonsamples_German[3])
            else
                displayChat(commonsamples[3])
            setStatus(changeLanguage('status', 'exampletext19'))
        }
        if (sample === "Description")
        {
            console.log("Description Sample:", commonsamples[4])
            if (mainLanguage === 'Serbian')
                displayChat(commonsamples_Serbian[4])
            else if (mainLanguage === 'Spanish')
                displayChat(commonsamples_Spanish[4])
            else if (mainLanguage === 'Portuguese')
                displayChat(commonsamples_Portuguese[4])
            else if (mainLanguage === 'French')
                displayChat(commonsamples_French[4])
            else if (mainLanguage === 'German')
                displayChat(commonsamples_German[4])
            else
            displayChat(commonsamples[4])
            setStatus(changeLanguage('status', 'exampletext19'))
        }
        if (sample === "Email")
        {
            console.log("Email Sample:", commonsamples[5])
            if (mainLanguage === 'Serbian')
               displayChat(commonsamples_Serbian[5])
            else  if (mainLanguage === 'Spanish')
               displayChat(commonsamples_Spanish[5])
            else if (mainLanguage === 'Portuguese')
               displayChat(commonsamples_Portuguese[5])
            else if (mainLanguage === 'French')
               displayChat(commonsamples_French[5])
            else if (mainLanguage === 'German')
               displayChat(commonsamples_German[5])
            else
                displayChat(commonsamples[5])
            setStatus(changeLanguage('status', 'exampletext19'))
        }
        if (sample === "Story")
        {
            console.log("Story Sample:", commonsamples[6])
            if (mainLanguage === 'Serbian')
                displayChat(commonsamples_Serbian[6])
            else if (mainLanguage === 'Spanish')
                displayChat(commonsamples_Spanish[6])
            else if (mainLanguage === 'Portuguese')
                displayChat(commonsamples_Portuguese[6])
            else if (mainLanguage === 'French')
                displayChat(commonsamples_French[6])
            else if (mainLanguage === 'German')
                displayChat(commonsamples_German[6])
            else
                displayChat(commonsamples[6])
            setStatus(changeLanguage('status', 'exampletext19'))
        }
        if (sample === "Improve")
        {
            console.log("Improve Sample:", commonsamples[7])
            if (mainLanguage === 'Serbian')
                displayChat(commonsamples_Serbian[7])
            else if (mainLanguage === 'Spanish')
                displayChat(commonsamples_Spanish[7])
            else if (mainLanguage === 'Portuguese')
                displayChat(commonsamples_Portuguese[7])
            else if (mainLanguage === 'French')
                displayChat(commonsamples_French[7])
            else if (mainLanguage === 'German')
                displayChat(commonsamples_German[7])
            else
                displayChat(commonsamples[7])
            setStatus(changeLanguage('status', 'exampletext19'))
        }

    }
    const onDeleteCustomPrompt = () => {
       
        let a = customprompts.filter(prompt => prompt.id !== customprompt.id)
       
        setCustomPrompts(a);
        saveCustomPrompts(a)
    }

    const onSaveCustomPrompts = async () => {

        let updatedPrompts

        if (addpromptmode)
        {
            //add new prompt
            let b = {
                id: customprompts.length,
                default: false,
                name: customprompt.name,
                prompt: customprompt.prompt
            }
            addNewPrompt(b)

            updatedPrompts = [...customprompts, b]
           
        }
        else
        {
            //update existing prompt
            setCustomPrompts(prevPrompts => 
                prevPrompts.map(prompt => 
                    prompt.id === customprompt.id ? customprompt : prompt
                )
            );
            

            updatedPrompts = customprompts.map(prompt=>
                prompt.id === customprompt.id ? customprompt : prompt
            )
            
        }

        saveCustomPrompts(updatedPrompts)
     
        
    }

    const saveCustomPrompts = async (updatedprompts) => {
        
        setIsLoading(true)

        try
        {
            let prompts = JSON.stringify(updatedprompts)
           
            await axios.post(config.url.API_URL + "/deda_ai_api/customprompts/savecustomprompts", {currentUser, prompts},{
                    withCredentials:true
            })  
        }
         catch (err) {
           
            setStatus(`Error: ${checkServerCode(err.code)}`)
         }

         setIsLoading(false)

    }

    const promptNameExists = () => {
        for (const item of customprompts) {
            if (item.name === customprompt.name)
            {
               return true;
            }
        }
        return false;
    }
   
    const onClearChat = () => {
        setPromptsAndResponses([])
        setConfirmDelete([])
        setChatName('')
        setStatus('')
        setChatPrompt('')

    }

    const deleteChat = async (deletionChat) => {
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }
        let newchatNames = [];
        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/commontasks/get", {currentUser}) 
            newchatNames =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }
        let filteredChats = newchatNames.filter(chat => chat.id !== deletionChat.id)
        let adjustedChats = sortChats(filteredChats)
        
        var templates = JSON.stringify(adjustedChats)
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/commontasks/save", { currentUser, templates }, {
                withCredentials: true
            })
        }
        catch (err) {
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }
        setChatNames(adjustedChats);
        setIsLoading(false)
    }

    const displayChat = (displayedChat) => {

        onClearChat();

        setTimeout(() => {

        //fix prompts ids to match array indexes
        let index = 0;
           displayedChat.promptsandresponses.forEach((item) => {
            item.id = index;
            index++
        })

        setPromptsAndResponses(displayedChat.promptsandresponses)
        setChatName(displayedChat.chatname)

        var deletes = []
        displayedChat.promptsandresponses.forEach((item) => {
            let a = {
                id: item.id,
                state: false
            }
            deletes.push(a)
        })

        setConfirmDelete(deletes)
        },0)
    }

    const onDeletePrompt = (deletionChat) => {
        if (isLoading)
            return;
        //console.log("Common: onDeletePrompt")
        let index = promptsandresponses.indexOf(deletionChat)

        let filteredChats = promptsandresponses.filter(chat => chat.id !== deletionChat.id)
        setPromptsAndResponses(filteredChats)

        let deleteconfirm = [...confirmDelete]

        deleteconfirm.splice(index, 1)
        setConfirmDelete(deleteconfirm)

    }

    const changeConfirmDelete = (prompt, flag) => {
        let a = [...confirmDelete]
        a.forEach((item) => {
            if (item.id === prompt.id)
                item.state = flag
        })

        setConfirmDelete(a)
    }

    const onSave = async () => {

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return
        }

        let exists = false;

        let newChats = [];
        let newChat = [];
        let newchatNames = [];
      
        setIsLoading(true);

        let chatstatus = await getChats('commontasks');
       
        if (chatstatus.status !== 200)
        {
            setStatusNavbar("Unable to retrieve topics data.")
           
            setIsLoading(false);
            return;
        }

        newchatNames = chatstatus.chats;

        if ( chatstatus.status === 200)
        {
            newchatNames.forEach((chat) => {
                if (chat.chatname === chatName) {
                    let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }
                    
                    chat.promptsandresponses = promptsandresponses;
                    newChat = chat;
                    exists = true;
                }
                newChats.push(JSON.parse(JSON.stringify(chat)));
            })
        }

        if (!exists) {
            let i = 0
            newchatNames === 0 ? i = 0 : i = newchatNames.length;
            newChat = {
                id: i,
                chatname: chatName,
                promptsandresponses: promptsandresponses,
            };
            newChats.push(newChat);
            
            let adjustedChats = sortChats(newChats)
            newChats = [...adjustedChats]
        }

        let templates = JSON.stringify(newChats)
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/commontasks/save", { currentUser, templates }, {
                withCredentials: true
            })
        }
        catch (err) {
            setIsLoading(false);
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
            return
        }

        setChatNames(newChats)
        setIsLoading(false);
       
    }

    
    const onSubmitChat = () => {
        //console.log('OnSubmitChat:', chatPrompt)
        let text = ''
        SendRequest(chatPrompt, text, false)
    }

    const onResubmitChat = (prompt) => {
        //console.log("onResubmitQuestion:", prompt)
        let text = ''
        SendRequest(prompt.prompt, text, false)
    }

    const onSubmitPrompt = (prompt) => {
        //console.log('OnSubmitPrompt:', chatPrompt)
        setDisplayCustomPromptsDialog(false)

        SendRequest(chatPrompt, prompt, true)
    }

    async function SendRequest(request, task, combinerequestandtask) {
       
        setStatus('')
     
        if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }
       
        if (request.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }

        let i = 0;
        if (promptsandresponses.length) {
            i = promptsandresponses[promptsandresponses.length - 1].id + 1
        }

        let r = {
            id: i,
            prompt: request,
            response: "",
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
        if (combinerequestandtask)
        {
            r.prompt = task + request
        }

        setPromptsAndResponses([...promptsandresponses, r])

        if (promptsandresponses.length > 0)
            {
                setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
                handleFocus()
            }
        if (confirmDelete.length <= promptsandresponses.length) {
            let a = {
                id: i,
                state: false
            }
            setConfirmDelete([...confirmDelete, a])
        }
        let rqst = task + request

        setChatPrompt('')
      
        let req = {
            user:currentUser,
            request: rqst,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
          
        }

        setIsLoading(true)
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })
          

            let server_response = JSON.parse(res.data);

            if (promptsandresponses.length) {
                i = promptsandresponses[promptsandresponses.length - 1].id + 1
            } else i = 0
            r = {
                id: i,
                prompt: request,
                response: server_response.data,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            }

            if (combinerequestandtask)
            {
                r.prompt = task + request
            }

            setPromptsAndResponses([...promptsandresponses, r])
            setWaitOnResponse('')
            updateCredits(server_response.tokens)
           

        } catch (err) {
          
            console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
            setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
        }
        setIsLoading(false)
    }

    
    

    return <CommonTasksContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse,
        promptsandresponses,
        chatName,
        chatNames,
        setChatName,
        setChatNames,
        onSubmitChat,
        onSubmitPrompt,
        onClearChat,
        onSave,
        deleteChat,
        displayChat,
        onDeletePrompt,
        changeConfirmDelete,
        confirmDelete,
        
        displaySample,
        status,
        setStatus,
        setShowCustomPromptDialog,
        showcustompromptdialog,
   
        setCustomPrompt,
        customprompt,
        showdeletedialog, 
        setShowDeleteDialog,
        showsavedialog, 
        dialogboxtext,

        onSaveCustomPrompts,
        sortedPrompts,
        promptNameExists,
        addpromptmode, 
        setAddPromptMode,

        onDeleteCustomPrompt,
        customprompts,
        getPromptIndexByName,

        onResubmitChat,

        displaycustompromptsdialog,
        setDisplayCustomPromptsDialog,

        fetchPrompts,

        statusCustomPrompts,
        setCustomPromptsStatus,

        onShowDeleteCustomPromptDialog,
        setShowSaveDialog
    }}>
        {props.children}
    </CommonTasksContext.Provider>
})